import React, { Component } from "react";
import Head from "next/head";
import dynamic from "next/dynamic";
import { withRouter } from "next/router";
import Loading from "./../../src/components/Loading";
import AuthChecker from "./../../src/common/AuthChecker";
import StructuredData from "./../../src/components/StructuredData";
//import Navbar from "./../../src/components/NavigationBar/Navbar";
//import Footer from "./../../src/components/Footer";

const UserCommunityComponent = dynamic(import("./../../src/pages/UserCommunity/UserCommunity"), {
	loading: () => <Loading />
});

class UserCommunity extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		let value = this.context;
	}

	render() {
		return (
			<>
				<UserCommunityComponent
					router={this.props.router}
					newUserLogin={
						this.props.router.isReady ? this.props.router.query.signIn : false
					}
				/>
			</>
		);
	}
}
export async function getServerSideProps(ctx) {
	await AuthChecker(ctx, false);
	return { props: {} };
}

export default withRouter(UserCommunity);
